import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { MessageCircle, Mail, Bell, Wallet, Phone, Users } from 'lucide-react';
import { money, fmtDate, waLink, mailLink, STATE_BADGE, installmentText } from '../lib/share';

export const InstallmentRow = ({ it, onPay, onNotify, canPay }) => {
  const [amt, setAmt] = useState(it.balance);
  const [ref, setRef] = useState('');
  const [open, setOpen] = useState(false);
  const c = it.client || {};
  const text = installmentText(it);
  const contacts = [
    { label: 'Cliente', name: c.name, phone: c.phone },
    { label: c.contact1_relation || 'Contacto 1', name: c.contact1_name, phone: c.contact1_phone },
    { label: c.contact2_relation || 'Contacto 2', name: c.contact2_name, phone: c.contact2_phone },
  ].filter((x) => x.phone);
  return (
    <div className="border border-[#E2E8F0] rounded-lg p-3 bg-white" data-testid={`installment-row-${it.installment_id}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <p className="font-bold text-[#022C22]">{c.name} <span className="text-xs text-[#94A3B8]">C.I. {c.cedula_rif}</span></p>
          <p className="text-xs text-[#64748B]">{it.invoice_number} · Cuota #{it.number}/{it.total_installments} · vence {fmtDate(it.due_date)} · {it.company_name}{it.seller_name ? ` · Vend. ${it.seller_name}` : ''}</p>
          <p className="text-xs text-[#64748B]">{(it.products || []).join(', ')}</p>
        </div>
        <div className="text-right">
          <p className="font-heading font-black text-lg text-[#022C22]">{money(it.balance)}</p>
          <span className={`text-[11px] px-2 py-0.5 rounded-full font-semibold ${STATE_BADGE[it.state]}`}>{it.state === 'vencida' ? `Vencida · ${it.days_overdue} d` : it.state}</span>
        </div>
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {contacts.map((ct, i) => (
          <a key={i} href={waLink(ct.phone, text)} target="_blank" rel="noreferrer" data-testid={`wa-${i}-${it.installment_id}`}
            className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-green-50 text-green-700 hover:bg-green-100">
            {i === 0 ? <MessageCircle size={12} /> : <Users size={12} />} {ct.label}: {ct.name} {ct.phone}
          </a>
        ))}
        {c.phone && <a href={`tel:${c.phone}`} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-slate-50 text-slate-700"><Phone size={12} /> Llamar</a>}
        {c.email && <a href={mailLink(c.email, 'Recordatorio de cuota', text)} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-blue-50 text-blue-700"><Mail size={12} /> Correo</a>}
        <button onClick={() => onNotify([it.installment_id], ['internal', 'email'])} data-testid={`notify-${it.installment_id}`}
          className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-amber-50 text-amber-700"><Bell size={12} /> Notificar (interna + email)</button>
        {canPay && <button onClick={() => setOpen(!open)} data-testid={`pay-toggle-${it.installment_id}`} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md bg-primary/10 text-primary font-semibold"><Wallet size={12} /> Registrar pago</button>}
      </div>
      {open && (
        <div className="mt-2 flex flex-wrap gap-2 items-center">
          <Input className="w-28 h-8" type="number" value={amt} onChange={(e) => setAmt(e.target.value)} data-testid={`pay-amount-${it.installment_id}`} />
          <Input className="w-40 h-8" placeholder="Referencia / método" value={ref} onChange={(e) => setRef(e.target.value)} />
          <Button size="sm" data-testid={`pay-submit-${it.installment_id}`} onClick={() => onPay(it, parseFloat(amt), ref)}>Confirmar</Button>
        </div>
      )}
    </div>
  );
};

export default InstallmentRow;
